import React from 'react';
import createSvgIcon from '../../../utils/createSvgIcon';

export default createSvgIcon(
  [<g key="0"><path fill="currentColor" d="M7 2v11h3v9l7-12h-4l3-8z" /></g>,<defs key="1"></defs>,]
, 'CameraPhotoFlashOnx');
